import { Employee } from '../store/employees/types'
import { Salon } from '../store/salon'
import { ServiceCategory } from '../store/services/types'
import { callApi } from '../utils/api'
import { endpoints } from './config'

type SalonDataResponse = Salon & {
  mitarbeiter: Employee[]
  servicesKategorien: ServiceCategory[]
}

export const getSalonData = async (salonGuid: string): Promise<SalonDataResponse | null> => {
  const response = await callApi<SalonDataResponse>({ path: endpoints.salonData, body: { guid: salonGuid } })

  if (!response.isOk || !response.data) {
    return null
  }

  return response.data
}
